import React, { useEffect, useState } from 'react';
import AddLocationModal  from '../../components/Configs/AddLocationModal';
import EditLocationModal  from '../../components/Configs/EditLocationModal';
import { Row, Col, Button, Table, Badge } from 'react-bootstrap';
import { getLocations } from '../../services/Configs/LocationsService'; 


function Locations(){ 
    const [showAddLocationModal, setShowAddLocationModal] = useState(false);
    const [showEditLocationModal, setShowEditLocationModal] = useState(false);
    const [reload, setReload] = useState(false);
    const [selectedLocationId, setSelectedLocationId] = useState(0);
    const handleAddLocation = () => {
        setShowAddLocationModal(true);
    }
    const handleOpenEditModal = (id) => {
        setSelectedLocationId(id);
        setShowEditLocationModal(true);
    }

    const [locations, setLocations] = useState([]);

    useEffect(() => {
        getLocations().then(list => {
            setLocations(list);
        })
    },[reload])
    return (
        <>
        <Row>
            <Col xl={3}>
                <Button variant='info' onClick={handleAddLocation} >Agregar</Button>
            </Col>
        </Row>
        <Row>
            <Col xl={12}>
                <Table className='mb-5 mt-3' striped bordered hover responsive>
                    <thead>
                        <tr>
                            <th className='text-center'>
                                Opciones
                            </th>
                            <th className='text-center'>
                                Nombre
                            </th>
                            <th className='text-center'>
                                Estatus
                            </th>
                        </tr>
                    </thead>
                    <tbody>
                    { 
                        locations.length == 0 ? (
                            <Row >
                                <Col xl={12} >
                                    <h4>No hay Ubicaciones</h4>
                                </Col>
                            </Row>
                        ) :
                        locations.map((item, index) => (
                            
                            <tr key={index} >
                                <td className='text-center'>
                                    <Button variant='secondary' onClick={() => {handleOpenEditModal(item.id)}} >...</Button>
                                </td>
                                <td className='text-center'>
                                    {item.name}
                                </td>
                                <td className='text-center'>
                                {item.isActive ?   <Badge bg="success">Activa</Badge> : <Badge bg="danger">Inactiva</Badge>  }
                                </td>
                            </tr>
                        ))
                    }
                    </tbody>
                </Table>     
            </ Col>
        </Row>
        <AddLocationModal
        show={showAddLocationModal}
        handleClose={() => setShowAddLocationModal(false)}
        handleReload={() => { setReload(!reload) }}
         />
        <EditLocationModal
        locationId={selectedLocationId}
        show={showEditLocationModal}
        handleClose={() => setShowEditLocationModal(false)}
        handleReload={() => { setReload(!reload) }}
         />

        
         </>
    )
}
export default Locations